/**
 * Vuex module for contact tags
 */
import debug from 'debug'
import API from '@/api'
import Tag from 'Store/class/contact/tag'
import events from 'Store/events'

const dbg = debug('store:contactTag:')

const actions = {
  get ({ commit, state }) {
    dbg('Getting contact tags')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      return API.getContactTags()
        .then(response => {
          commit('ADD_TAGS', response.data)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get contact tags'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  create ({ commit }, tag) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('CREATE_TAG', tag)
  },

  update ({ commit }, tag) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('UPDATE_TAG', tag)
  },

  delete ({ commit }, tag) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('DELETE_TAG', tag)
  }
}

const mutations = {
  ADD_TAGS (state, data) {
    const tags = []
    data.forEach(tag => {
      tags.push(new Tag(tag))
    })
    state.tags = tags
  },

  CREATE_TAG (state, tag) {
    API.createContactTag(tag).then(resp => {
      this.dispatch('contacts/tags/get')
      this.dispatch('contacts/get')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to create contact tag')
    })
  },

  UPDATE_TAG (state, tag) {
    API.updateContactTag(tag).then(resp => {
      this.dispatch('contacts/tags/get')
      this.dispatch('contacts/get')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to update contact tag')
    })
  },

  DELETE_TAG (state, tag) {
    API.deleteContactTag(tag).then(resp => {
      this.dispatch('contacts/tags/get')
      this.dispatch('contacts/get')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to delete contact tag')
    })
  }
}

const state = {
  tags: []
}

const getters = {
  tags: state => state.tags
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
